import { render, staticRenderFns } from "./VAdministrationWidget.vue?vue&type=template&id=25f9b2c4&functional=true&"
var script = {}
import style0 from "./VAdministrationWidget.vue?vue&type=style&index=0&id=25f9b2c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports